var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDocument24Line = function SvgIconDocument24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.835 8.835a.719.719 0 0 0-.075-.205c-.01-.015-.015-.035-.025-.05a.771.771 0 0 0-.135-.18l-4-4a.94.94 0 0 0-.18-.135c-.015-.01-.03-.015-.045-.025A.863.863 0 0 0 14 4.15H7.8c-1.46 0-2.65 1.19-2.65 2.65v10.4c0 1.46 1.19 2.65 2.65 2.65h8.4c1.46 0 2.65-1.19 2.65-2.65V9a.92.92 0 0 0-.015-.165ZM15.95 8.15h-1.1v-1.1l1.1 1.1Zm.25 10H7.8a.95.95 0 0 1-.95-.95V6.8a.95.95 0 0 1 .95-.95h5.35V8.4c0 .8.65 1.45 1.45 1.45h2.55v7.35a.95.95 0 0 1-.95.95Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.15H9v1.7h6v-1.7ZM15 14.65H9v1.7h6v-1.7Z",
    fill: "current"
  })));
};
export default SvgIconDocument24Line;